module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--register main--register-dentist"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _c('ui-auth', {
    attrs: {
      "title": "Create Your Dentist Account",
      "slug": "registerDentist",
      "copy": "Create your account to join the growing team of experts demonstrating quality in dentistry.  Your account will allow you to submit your patient’s radiographs for review and track their progress.  You can also request to become an independent reviewer of other’s work.",
      "terms": _vm.terms,
      "submit": "Create Account"
    }
  }, [_c('div', {
    attrs: {
      "slot": "top-link"
    },
    slot: "top-link"
  }, [_c('p', {
    staticClass: "small"
  }, [_vm._v("Already have an account? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Log in")]), _vm._v(" "), _c('br'), _vm._v("Not a dentist? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register-patient'
      }
    }
  }, [_vm._v("Register as a Patient")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "before-submit"
    },
    slot: "before-submit"
  }, [_c('p', {
    staticClass: "mt0 mb0 small"
  }, [_vm._v("By signing up you agree to the VeriTooth")]), _vm._v(" "), _c('p', {
    staticClass: "mt0 small"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'terms'
      },
      "target": "_blank"
    }
  }, [_vm._v("Terms & Conditions")]), _vm._v(" and "), _c('router-link', {
    attrs: {
      "to": {
        name: 'privacy'
      },
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26c67c2c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/register/RegisterDentist.vue
// module id = 318
// module chunks = 0